import ClickOutside from 'vuetify/lib/directives/click-outside';

import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "vendas-pdv-page"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_vm._m(0), _c('div', {
    staticClass: "header-actions"
  }, [_c('button', {
    staticClass: "vp-btn vp-btn--primary",
    on: {
      "click": function click($event) {
        return _vm.$router.push({
          name: 'pdvDesktopNovaVenda'
        });
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-plus mr-1"
  }), _vm._v(" Nova venda ")]), _c('button', {
    staticClass: "vp-btn vp-btn--outline",
    attrs: {
      "disabled": _vm.sincronizandoPendentes || !_vm.online,
      "title": !_vm.online ? 'Disponível somente com internet' : ''
    },
    on: {
      "click": _vm.sincronizarPendentes
    }
  }, [_vm.sincronizandoPendentes ? _c('span', [_c('span', {
    staticClass: "spinner-border spinner-border-sm mr-1"
  }), _vm._v("Sincronizando... ")]) : _c('span', [_c('i', {
    staticClass: "fas fa-paper-plane mr-1"
  }), _vm._v("Sincronizar pendentes ")])]), _c('button', {
    staticClass: "vp-btn vp-btn--outline",
    attrs: {
      "disabled": _vm.carregando
    },
    on: {
      "click": _vm.recarregar
    }
  }, [_c('i', {
    staticClass: "fas fa-sync-alt mr-1"
  }), _vm._v("Atualizar ")]), _c('button', {
    staticClass: "vp-btn vp-btn--outline",
    attrs: {
      "disabled": _vm.exportandoXml
    },
    on: {
      "click": _vm.abrirBackupXml
    }
  }, [_c('i', {
    staticClass: "fas fa-file-export mr-1"
  }), _vm._v("Backup XML ")]), _c('button', {
    staticClass: "vp-btn vp-btn--ghost",
    on: {
      "click": function click($event) {
        return _vm.$router.push({
          name: 'pdvDesktopDashboard'
        });
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-arrow-left mr-1"
  }), _vm._v("Voltar ao PDV ")])])]), _vm.erro ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_vm._v(_vm._s(_vm.erro))]) : _vm._e(), _vm.sucesso ? _c('div', {
    staticClass: "alert alert-success"
  }, [_vm._v("✓ " + _vm._s(_vm.sucesso))]) : _vm._e(), _c('div', {
    staticClass: "filters-card"
  }, [_c('form', {
    staticClass: "filters-grid",
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.aplicarFiltros.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "filter-field"
  }, [_c('label', [_vm._v("Cliente")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.filtros.cliente,
      expression: "filtros.cliente"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Nome do cliente"
    },
    domProps: {
      "value": _vm.filtros.cliente
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.filtros, "cliente", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "filter-field"
  }, [_c('label', [_vm._v("Número")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.filtros.numero,
      expression: "filtros.numero"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Nº venda/NFC-e"
    },
    domProps: {
      "value": _vm.filtros.numero
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.filtros, "numero", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "filter-field"
  }, [_c('label', [_vm._v("De")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.filtros.dataInicio,
      expression: "filtros.dataInicio"
    }],
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": _vm.filtros.dataInicio
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.filtros, "dataInicio", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "filter-field"
  }, [_c('label', [_vm._v("Até")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.filtros.dataFim,
      expression: "filtros.dataFim"
    }],
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": _vm.filtros.dataFim
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.filtros, "dataFim", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "filter-field"
  }, [_c('label', [_vm._v("Status")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.filtros.status,
      expression: "filtros.status"
    }],
    on: {
      "change": function change($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.filtros, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Todos")]), _c('option', {
    attrs: {
      "value": "pre_venda"
    }
  }, [_vm._v("Pré-venda")]), _c('option', {
    attrs: {
      "value": "autorizada"
    }
  }, [_vm._v("Autorizada")]), _c('option', {
    attrs: {
      "value": "pendente_transmissao_backend"
    }
  }, [_vm._v("Pendente transmissão")]), _c('option', {
    attrs: {
      "value": "xml_assinado"
    }
  }, [_vm._v("XML assinado")]), _c('option', {
    attrs: {
      "value": "pendente_xml"
    }
  }, [_vm._v("Pendente XML")]), _c('option', {
    attrs: {
      "value": "rejeitada"
    }
  }, [_vm._v("Rejeitada")]), _c('option', {
    attrs: {
      "value": "erro_transmissao"
    }
  }, [_vm._v("Erro transmissão")]), _c('option', {
    attrs: {
      "value": "cancelada"
    }
  }, [_vm._v("Cancelada")])])]), _c('div', {
    staticClass: "filter-field"
  }, [_c('label', [_vm._v("Tipo emissão")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.filtros.tipoEmissao,
      expression: "filtros.tipoEmissao"
    }],
    on: {
      "change": function change($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.filtros, "tipoEmissao", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Todos")]), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Normal")]), _c('option', {
    attrs: {
      "value": "9"
    }
  }, [_vm._v("Contingência")])])]), _c('div', {
    staticClass: "filter-actions"
  }, [_vm._m(1), _c('button', {
    staticClass: "vp-btn vp-btn--ghost vp-btn--sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.limparFiltros
    }
  }, [_vm._v(" Limpar ")])])])]), _c('div', {
    staticClass: "sales-table-card"
  }, [_vm.carregando ? _c('div', {
    staticClass: "vp-loading"
  }, [_c('span', {
    staticClass: "spinner-border spinner-border-sm mr-2"
  }), _vm._v("Carregando vendas... ")]) : _c('div', {
    staticClass: "sales-table-wrapper"
  }, [_c('table', {
    staticClass: "vp-table"
  }, [_vm._m(2), _c('tbody', [_vm.vendas.length === 0 ? _c('tr', [_c('td', {
    staticClass: "text-center text-muted py-4",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v(" Nenhuma venda encontrada com os filtros atuais. ")])]) : _vm._e(), _vm._l(_vm.vendas, function (nfce) {
    return _c('tr', {
      key: nfce.uuid_venda_terminal
    }, [_c('td', {
      staticClass: "vp-numero"
    }, [_vm._v(_vm._s(_vm.numeroVendaExibicao(nfce)))]), _c('td', [_vm._v(_vm._s(nfce.serie || '—'))]), _c('td', [_vm._v(_vm._s(_vm._f("dataHora")(nfce.emissao || nfce.dtVenda || nfce.created_at)))]), _c('td', [_vm._v(_vm._s(nfce.nomeCliente || 'Consumidor final'))]), _c('td', {
      staticClass: "text-right font-monospace"
    }, [_vm._v(_vm._s(_vm._f("brl")(nfce.valorTotal)))]), _c('td', [_c('span', {
      class: ['vp-badge', _vm.badgeClassStatusVenda(nfce)]
    }, [_vm._v(" " + _vm._s(_vm.labelStatusVenda(nfce)) + " ")])]), _c('td', [_vm.statusEfetivo(nfce) === 'pre_venda' ? _c('span', {
      staticClass: "vp-badge vp-badge--info",
      attrs: {
        "title": "Venda concluída com XML preparado, ainda não transmitido à SEFAZ"
      }
    }, [_vm._v("Pré-venda")]) : _vm.getTpEmis(nfce) === 9 ? _c('span', {
      staticClass: "vp-badge vp-badge--warning",
      attrs: {
        "title": "NFC-e emitida em contingência offline"
      }
    }, [_vm._v("Contingência")]) : _c('span', {
      staticClass: "vp-badge vp-badge--neutral"
    }, [_vm._v("Normal")])]), _c('td', {
      staticClass: "text-center vp-table__actions"
    }, [_c('button', {
      staticClass: "vp-btn vp-btn--outline vp-btn--sm",
      on: {
        "click": function click($event) {
          $event.stopPropagation();
          return _vm.toggleMenu(nfce.uuid_venda_terminal);
        }
      }
    }, [_vm._v(" Ações "), _c('i', {
      staticClass: "fas fa-caret-down ml-1"
    })]), _vm.menuAberto === nfce.uuid_venda_terminal ? _c('div', {
      directives: [{
        def: ClickOutside,
        name: "click-outside",
        rawName: "v-click-outside",
        value: _vm.closeMenu,
        expression: "closeMenu"
      }],
      staticClass: "vp-dropdown"
    }, _vm._l(_vm.acoesDisponiveis(nfce), function (acao) {
      return _c('button', {
        key: acao.key,
        staticClass: "vp-dropdown__item",
        class: acao.classe || '',
        attrs: {
          "disabled": acao.disabled === true,
          "title": acao.title || ''
        },
        on: {
          "click": function click($event) {
            return _vm.executarAcao(acao, nfce);
          }
        }
      }, [acao.icone ? _c('i', {
        staticClass: "mr-2",
        class: acao.icone
      }) : _vm._e(), _vm._v(" " + _vm._s(acao.label) + " ")]);
    }), 0) : _vm._e()])]);
  })], 2)])]), !_vm.carregando && _vm.podeCarregarMais ? _c('div', {
    staticClass: "vp-load-more"
  }, [_c('button', {
    staticClass: "vp-btn vp-btn--outline",
    attrs: {
      "disabled": _vm.carregandoMais
    },
    on: {
      "click": _vm.carregarMais
    }
  }, [_vm.carregandoMais ? _c('span', [_c('span', {
    staticClass: "spinner-border spinner-border-sm mr-1"
  }), _vm._v("Carregando... ")]) : _c('span', [_vm._v("Carregar mais")])])]) : _vm._e()]), _vm.modalCorrigir.visivel && _vm.modalCorrigir.nfce ? _c('CorrigirFiscalModal', {
    attrs: {
      "nfce": _vm.modalCorrigir.nfce
    },
    on: {
      "fechar": function fechar($event) {
        _vm.modalCorrigir.visivel = false;
      },
      "atualizar": _vm._onCorrecaoAtualizada
    }
  }) : _vm._e(), _c('DanfeNfce', {
    attrs: {
      "visivel": _vm.modalDanfe.visivel,
      "uuid": _vm.modalDanfe.uuid
    },
    on: {
      "fechar": function fechar($event) {
        _vm.modalDanfe.visivel = false;
      }
    }
  }), _vm.modalDetalhe.visivel && _vm.modalDetalhe.nfce ? _c('NfceDetalheModal', {
    attrs: {
      "nfce": _vm.modalDetalhe.nfce
    },
    on: {
      "fechar": function fechar($event) {
        _vm.modalDetalhe.visivel = false;
      }
    }
  }) : _vm._e(), _vm.modalCancelar.visivel && _vm.modalCancelar.nfce ? _c('CancelarNfceModal', {
    attrs: {
      "nfce": _vm.modalCancelar.nfce
    },
    on: {
      "fechar": _vm.fecharModalCancelar,
      "cancelado": _vm._onNfceCancelada
    }
  }) : _vm._e(), _vm.modalXml.visivel ? _c('div', {
    staticClass: "vp-modal-overlay",
    on: {
      "click": function click($event) {
        if ($event.target !== $event.currentTarget) return null;
        return _vm.fecharModalXml.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "vp-modal-xml"
  }, [_c('div', {
    staticClass: "vp-modal-xml__header"
  }, [_c('div', [_c('h4', {
    staticClass: "vp-modal-xml__title"
  }, [_vm._v(" " + _vm._s(_vm.modalXml.titulo) + " ")]), _vm.modalXml.nfce && _vm.modalXml.nfce.chave ? _c('small', {
    staticClass: "text-muted"
  }, [_vm._v(" Chave: " + _vm._s(_vm.modalXml.nfce.chave) + " ")]) : _vm._e()]), _c('button', {
    staticClass: "vp-btn vp-btn--ghost",
    on: {
      "click": _vm.fecharModalXml
    }
  }, [_vm._v("✕")])]), _vm.modalXml.conteudo ? _c('pre', {
    staticClass: "vp-modal-xml__content"
  }, [_vm._v(_vm._s(_vm.modalXml.conteudo))]) : _c('div', {
    staticClass: "vp-modal-xml__empty"
  }, [_vm._v(" " + _vm._s(_vm.modalXml.mensagemVazio) + " ")]), _c('div', {
    staticClass: "vp-modal-xml__footer"
  }, [_vm.xmlCopiado ? _c('span', {
    staticClass: "text-success mr-3 font-weight-bold"
  }, [_c('i', {
    staticClass: "fas fa-check mr-1"
  }), _vm._v(_vm._s(_vm.mensagemToast || 'Copiado!') + " ")]) : _vm._e(), _c('button', {
    staticClass: "vp-btn vp-btn--outline vp-btn--sm",
    attrs: {
      "disabled": !_vm.modalXml.conteudo
    },
    on: {
      "click": _vm.copiarXmlAtivo
    }
  }, [_c('i', {
    staticClass: "fas fa-copy mr-1"
  }), _vm._v("Copiar XML ")])])])]) : _vm._e(), _vm.modalBackup.visivel ? _c('div', {
    staticClass: "vp-modal-overlay",
    on: {
      "click": function click($event) {
        if ($event.target !== $event.currentTarget) return null;
        return _vm.fecharBackupXml.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "vp-modal-backup"
  }, [_c('div', {
    staticClass: "vp-modal-backup__header"
  }, [_vm._m(3), _c('button', {
    staticClass: "vp-btn vp-btn--ghost",
    attrs: {
      "disabled": _vm.exportandoXml
    },
    on: {
      "click": _vm.fecharBackupXml
    }
  }, [_vm._v("✕")])]), _c('div', {
    staticClass: "vp-modal-backup__body"
  }, [_c('p', {
    staticClass: "text-muted"
  }, [_vm._v(" Selecione o período das NFC-e e a pasta onde os XMLs serão salvos. ")]), _c('div', {
    staticClass: "vp-backup-grid"
  }, [_c('div', {
    staticClass: "filter-field"
  }, [_c('label', [_vm._v("Data inicial")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.modalBackup.dataInicio,
      expression: "modalBackup.dataInicio"
    }],
    attrs: {
      "type": "date",
      "disabled": _vm.exportandoXml
    },
    domProps: {
      "value": _vm.modalBackup.dataInicio
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.modalBackup, "dataInicio", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "filter-field"
  }, [_c('label', [_vm._v("Data final")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.modalBackup.dataFim,
      expression: "modalBackup.dataFim"
    }],
    attrs: {
      "type": "date",
      "disabled": _vm.exportandoXml
    },
    domProps: {
      "value": _vm.modalBackup.dataFim
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.modalBackup, "dataFim", $event.target.value);
      }
    }
  })])]), _c('div', {
    staticClass: "filter-field"
  }, [_c('label', [_vm._v("Pasta de destino")]), _c('div', {
    staticClass: "vp-backup-pasta"
  }, [_c('input', {
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": _vm.modalBackup.pasta || 'Nenhuma pasta selecionada'
    }
  }), _c('button', {
    staticClass: "vp-btn vp-btn--outline vp-btn--sm",
    attrs: {
      "disabled": _vm.exportandoXml
    },
    on: {
      "click": _vm.selecionarPastaBackup
    }
  }, [_c('i', {
    staticClass: "fas fa-folder-open mr-1"
  }), _vm._v("Escolher ")])])]), _vm.backupErro ? _c('div', {
    staticClass: "alert alert-danger mt-2"
  }, [_vm._v(_vm._s(_vm.backupErro))]) : _vm._e(), _vm.modalBackup.resumo ? _c('div', {
    staticClass: "vp-backup-resumo"
  }, [_c('h5', [_vm._v("Resumo do backup")]), _c('ul', [_c('li', [_vm._v("XMLs encontrados: "), _c('strong', [_vm._v(_vm._s(_vm.modalBackup.resumo.encontrados))])]), _c('li', [_vm._v("Exportados: "), _c('strong', [_vm._v(_vm._s(_vm.modalBackup.resumo.exportados))])]), _c('li', [_vm._v("Com erro: "), _c('strong', [_vm._v(_vm._s(_vm.modalBackup.resumo.erros))])]), _c('li', [_vm._v("Não encontrados: "), _c('strong', [_vm._v(_vm._s(_vm.modalBackup.resumo.naoEncontrados))])]), _c('li', {
    staticClass: "vp-backup-resumo__path"
  }, [_vm._v("Pasta: "), _c('code', [_vm._v(_vm._s(_vm.modalBackup.resumo.destino))])])])]) : _vm._e()]), _c('div', {
    staticClass: "vp-modal-backup__footer"
  }, [_c('button', {
    staticClass: "vp-btn vp-btn--ghost",
    attrs: {
      "disabled": _vm.exportandoXml
    },
    on: {
      "click": _vm.fecharBackupXml
    }
  }, [_vm._v("Fechar")]), _c('button', {
    staticClass: "vp-btn vp-btn--primary",
    attrs: {
      "disabled": _vm.exportandoXml || !_vm.modalBackup.pasta
    },
    on: {
      "click": _vm.exportarXmls
    }
  }, [_vm.exportandoXml ? _c('span', [_c('span', {
    staticClass: "spinner-border spinner-border-sm mr-1"
  }), _vm._v("Exportando... ")]) : _c('span', [_c('i', {
    staticClass: "fas fa-download mr-1"
  }), _vm._v("Exportar XMLs")])])])])]) : _vm._e()], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('h1', {
    staticClass: "page-header__title"
  }, [_vm._v("Vendas do PDV")]), _c('p', {
    staticClass: "page-header__sub"
  }, [_vm._v(" Consulte, imprima, transmita e acompanhe as vendas emitidas neste terminal. ")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('button', {
    staticClass: "vp-btn vp-btn--primary vp-btn--sm",
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fas fa-search mr-1"
  }), _vm._v("Filtrar ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Número")]), _c('th', [_vm._v("Série")]), _c('th', [_vm._v("Emissão")]), _c('th', [_vm._v("Cliente")]), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Valor total")]), _c('th', [_vm._v("Status")]), _c('th', [_vm._v("Tipo")]), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Ações")])])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('h4', {
    staticClass: "vp-modal-backup__title"
  }, [_c('i', {
    staticClass: "fas fa-file-export mr-2"
  }), _vm._v("Backup de XMLs ")]);
}];
export { render, staticRenderFns };